var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-2": "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { xs12: "", md6: "", "pr-5": "", "pl-1": "" }
        },
        [
          _c(
            "v-flex",
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(_vm.lblSetting.equipmentModal.firstSectionTitle)
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isServiceBook
            ? [
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: {
                      required: "",
                      label: _vm.lblSetting.ticketImmeuble
                    }
                  },
                  [
                    _c("base-multi-select", {
                      key: 1,
                      attrs: {
                        icon: "icon icon-blocks",
                        "item-value": "value",
                        options: _vm.coBlocks,
                        "return-object": false,
                        multiple: false,
                        fetch: _vm.handleFetchBlocks
                      },
                      on: { change: _vm.handleChangeBlock },
                      model: {
                        value: _vm.Block,
                        callback: function($$v) {
                          _vm.Block = $$v
                        },
                        expression: "Block"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.coApartments.length
                  ? _c(
                      "base-control-label-vertical",
                      { attrs: { label: _vm.lblSetting.ticketAppartement } },
                      [
                        _c("base-autocomplete", {
                          attrs: {
                            items: _vm.coApartments,
                            "on-fetch-remote": _vm.handleGetApartments,
                            multiple: false,
                            "return-object": false,
                            clearable: true,
                            "item-value": "value"
                          },
                          model: {
                            value: _vm.Apartment,
                            callback: function($$v) {
                              _vm.Apartment = $$v
                            },
                            expression: "Apartment"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                label: "" + _vm.$t(_vm.lblSetting.equipmentHeaders.charPb1)
              }
            },
            [
              _c("v-autocomplete", {
                attrs: {
                  disabled: _vm.isVehicle,
                  rules: _vm.dtRules.characterProblemsRules_1,
                  "item-value": "id",
                  "item-text": "name",
                  items: _vm.characterProblems.level_1
                },
                on: { change: _vm.handleChangeCharPb1 },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function(data) {
                      return _c(
                        "v-chip",
                        {
                          staticClass: "chip--select-multi",
                          attrs: {
                            close: "",
                            color: !_vm.isVehicle ? "secondary" : "greyDarker",
                            "text-color": "whitePure"
                          },
                          on: { input: _vm.handleRemoveCharPb1 }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(data.item.name) +
                              "\n        "
                          )
                        ]
                      )
                    }
                  }
                ]),
                model: {
                  value: _vm.Lvl1,
                  callback: function($$v) {
                    _vm.Lvl1 = $$v
                  },
                  expression: "Lvl1"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: false,
                label: "" + _vm.$t(_vm.lblSetting.equipmentHeaders.charPb2)
              }
            },
            [
              _c("v-autocomplete", {
                attrs: {
                  "item-value": "id",
                  "item-text": "name",
                  items: _vm.characterProblems2
                },
                on: { change: _vm.handleChangeCharPb2 },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function(data) {
                      return _c(
                        "v-chip",
                        {
                          staticClass: "chip--select-multi",
                          attrs: {
                            close: "",
                            color: "secondary",
                            "text-color": "whitePure"
                          },
                          on: { input: _vm.handleRemoveCharPb2 }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(data.item.name) +
                              "\n        "
                          )
                        ]
                      )
                    }
                  }
                ]),
                model: {
                  value: _vm.Lvl2,
                  callback: function($$v) {
                    _vm.Lvl2 = $$v
                  },
                  expression: "Lvl2"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.equipmentHeaders.follow } },
            [
              _c("base-multi-select", {
                attrs: {
                  options: _vm.coContractors,
                  "item-value": "id",
                  "return-object": false,
                  multiple: true,
                  fetch: _vm.handleFilter
                },
                model: {
                  value: _vm.Contractors,
                  callback: function($$v) {
                    _vm.Contractors = $$v
                  },
                  expression: "Contractors"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { xs12: "", md6: "", "pl-3": "", "pr-5": "" }
        },
        [
          _c(
            "v-flex",
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(_vm.lblSetting.equipmentModal.secondSectionTitle)
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                label: _vm.lblSetting.equipmentHeaders.name
              }
            },
            [
              _c("v-text-field", {
                attrs: {
                  counter: _vm.textConfigs.input,
                  maxlength: _vm.textConfigs.input,
                  rules: _vm.dtRules.namesRules,
                  required: "",
                  solo: ""
                },
                model: {
                  value: _vm.Name,
                  callback: function($$v) {
                    _vm.Name = $$v
                  },
                  expression: "Name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.equipmentHeaders.description } },
            [
              _c("v-textarea", {
                attrs: {
                  name: "description",
                  counter: _vm.textConfigs.textarea,
                  maxlength: _vm.textConfigs.textarea,
                  rows: 2,
                  solo: ""
                },
                model: {
                  value: _vm.Description,
                  callback: function($$v) {
                    _vm.Description = $$v
                  },
                  expression: "Description"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.equipmentModal.brand } },
            [
              _c("v-text-field", {
                attrs: {
                  counter: _vm.textConfigs.input,
                  maxlength: _vm.textConfigs.input,
                  solo: ""
                },
                model: {
                  value: _vm.Brand,
                  callback: function($$v) {
                    _vm.Brand = $$v
                  },
                  expression: "Brand"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.equipmentModal.reference } },
            [
              _c("v-text-field", {
                attrs: {
                  counter: _vm.textConfigs.input,
                  maxlength: _vm.textConfigs.input,
                  solo: ""
                },
                model: {
                  value: _vm.Ref,
                  callback: function($$v) {
                    _vm.Ref = $$v
                  },
                  expression: "Ref"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.equipmentHeaders.location } },
            [
              _c("v-text-field", {
                attrs: {
                  counter: _vm.textConfigs.input,
                  maxlength: _vm.textConfigs.input,
                  solo: ""
                },
                model: {
                  value: _vm.Location,
                  callback: function($$v) {
                    _vm.Location = $$v
                  },
                  expression: "Location"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                label: _vm.$t(_vm.lblSetting.equipmentModal.number)
              }
            },
            [
              _c("v-text-field", {
                attrs: {
                  placeholder: "1",
                  solo: "",
                  type: "number",
                  rules: _vm.dtRules.nbEquipmentRules
                },
                model: {
                  value: _vm.NumberEquipment,
                  callback: function($$v) {
                    _vm.NumberEquipment = $$v
                  },
                  expression: "NumberEquipment"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                label: _vm.$t(_vm.lblSetting.equipmentDetail.acquisitionDate)
              }
            },
            [
              _c("v-text-field", {
                attrs: { placeholder: "2013", solo: "" },
                model: {
                  value: _vm.AcquisitionDate,
                  callback: function($$v) {
                    _vm.AcquisitionDate = $$v
                  },
                  expression: "AcquisitionDate"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-233e9702", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233e9702","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-equipment-modal-vertical/template.html
// module id = null
// module chunks = 